import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { homeBenefitLine, solutions } from '../../data/solutionCatalog';
import { DomainIcon } from '../demoCenter/DomainIcon';
import { easeOutStrong, fadeUp } from '../../utils/motion';

/** "Find your solution": seven concise cards linking to each solution's explanation. */
export function HomeSolutions() {
  return <section id="what-we-build" aria-labelledby="find-solution-title" className="scroll-mt-20 bg-surface-bg border-b border-line py-20 lg:py-28" data-id="element-1162" data-mp="mks0o2oipsjw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1163" data-mp="qjsjvmawqx7f">
        <motion.div {...fadeUp} className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12" data-id="element-1164" data-mp="vlq8yx5zom8a">
          <h2 id="find-solution-title" className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight" data-id="element-1165" data-mp="10j9k3o7e4iw0">
            Find your solution
          </h2>
          <a href="/solutions" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1166" data-mp="32acxgl8o0bk9">
            All solutions <ArrowRight size={16} aria-hidden="true" data-id="element-1167" data-mp="14huzouddp1bj" />
          </a>
        </motion.div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1168" data-mp="zklb1gxtctor">
          {solutions.map((solution, index) => <motion.li key={solution.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.25,
          delay: Math.min(index * 0.04, 0.24),
          ease: easeOutStrong
        }} className={`flex ${index === 0 ? 'lg:col-span-2' : ''}`} data-id="element-1169" data-mp="vjt10lh4akrf" data-mpi={index}>
              <a href={solution.href} className="group flex w-full flex-col rounded-lg border border-line bg-white p-6 hover:border-navy/40 transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1170" data-mp="1e86fbe6fcyy9">
                <DomainIcon id={solution.id} data-id="element-1171" data-mp="48n3lce5hhkz" />
                <h3 className="mt-5 font-heading font-bold text-lg text-ink-dark" data-id="element-1172" data-mp="98hydr11qrbb">{solution.pageTitle}</h3>
                <p className="mt-2 text-ink-muted leading-relaxed" data-id="element-1173" data-mp="3ree6c1mup8ol">{solution.summary}</p>
                <span className="mt-auto pt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-navy group-hover:text-navy-light transition-colors duration-150" data-id="element-1174" data-mp="3vfpzgh4xoc1j">
                  Explore <ArrowRight size={14} aria-hidden="true" data-id="element-1175" data-mp="3mgl2hf90sqrh" />
                </span>
              </a>
            </motion.li>)}
        </ul>

        <motion.p {...fadeUp} className="mt-10 font-heading font-semibold text-xl text-ink-dark" data-id="element-1176" data-mp="37szw9cgumbfc">
          {homeBenefitLine}
        </motion.p>
      </div>
    </section>;
}